import { fromUnixTime } from 'date-fns'
import API from '../config/axios'
import IBMAPI from '../config/axiosIBMConnect' // auto: bypass on localhost/nbtc.vptangddns.com, IBM otherwise

const sDOCAPI = {
	getLists: (isShowFinished, params = {}) => {
		return API.get('/SDoc', { params: { isShowFinished, ...params } })
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	getAvailableForAssign: () => {
		return API.get('/SDoc/AvailableForAssign')
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	getAllLists: (params = {}) => {
		return API.get('/SDoc/All', { params })
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	getListsApproved: (params = {}) => {
		return API.get('/SDoc/Approved', { params })
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	getListsV2: poa => {
		return API.get('/SDoc/v2?poa=' + poa)
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	getListDetail: id => {
		return API.get(`/SDoc/${id}`)
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	getListsStatus: () => {
		return API.get('/SDoc/Status')
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	getPreviewSDoC: (brandName, productModel, productDescription, owner, items, title) => {
		return API.post('/Document/PreviewSDoC/', {
			brandName,
			productModel,
			productDescription,
			owner,
			items,
			title,
		})
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err.response
			})
	},
	addList: (brandName, productModel, productDescription, owner, items) => {
		return IBMAPI.post('/SDoc', {
			brandName,
			productModel,
			productDescription,
			owner,
			items,
		})
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err.response
			})
	},
	editList: (id, brandName, productModel, productDescription, owner, items) => {
		return IBMAPI.post(`/SDoc/${id}`, {
			brandName,
			productModel,
			productDescription,
			owner,
			items,
		})
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err.response
			})
	},
	attachAdditionalFiles: async (sDOCID, files, onUploadProgress, onComplete) => {
		const CHUNK_SIZE = 1024 * 1024 * 2; // 2MB
		let totalSize = files.reduce((total, file) => total + file.file.size, 0);
		let totalUploaded = 0;
		let responses = [];

		const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

		const uploadChunk = async (file, currentChunk, fileIndex, bypassGateway = false) => {
			const start = file.chunkStart || 0;
			const end = Math.min(start + CHUNK_SIZE, file.file.size);
			const chunk = file.file.slice(start, end);

			if (!file.modifiedFileName) {
				const fileExtension = file.file.name.split('.').pop();
				const baseName = file.file.name.split('.').slice(0, -1).join('.');
				const randomSuffix = Math.floor(Math.random() * 100000);
				file.modifiedFileName = `${baseName}_Rnd${randomSuffix}_File${fileIndex}.${fileExtension}`;
			}

			const formData = new FormData();
			formData.append("file", chunk);
			formData.append("title", file.name);
			formData.append("originalFileName", file.modifiedFileName);
			formData.append("chunkNumber", currentChunk);
			formData.append("totalChunks", Math.ceil(file.file.size / CHUNK_SIZE));

			const config = {
				onUploadProgress: (progressEvent) => {
					const percentCompleted = Math.round(
						(totalUploaded + progressEvent.loaded) * 100 / totalSize
					);
					if (onUploadProgress) onUploadProgress(percentCompleted);
				},
			};

			let attempts = 0;
			let currentBypass = bypassGateway;
			while (attempts < 3) {
				try {
					let response;
					if (currentBypass) {
						// Already fell back for this file, use Direct API immediately
						response = await API.post(`/SDoc/${sDOCID}/attach`, formData, config);
					} else {
						// Try IBM first
						try {
							response = await IBMAPI.post(`/SDoc/${sDOCID}/attach`, formData, config);
						} catch (ibmErr) {
							console.log("IBM Upload Error:", ibmErr);
							if (ibmErr.response) {
								console.log("IBM Error Status:", ibmErr.response.status);
								console.log("IBM Error Data:", ibmErr.response.data);
							} else {
								console.log("IBM Error has no response property");
							}

							const isForbidden = ibmErr.response && ibmErr.response.status === 403;
							const isNetworkError = ibmErr.message === 'Network Error' || (ibmErr.code === 'ERR_NETWORK' && !ibmErr.response);
							
							if (isForbidden || isNetworkError) {
								console.warn(`IBM Gateway Error (403 or Network Error) on chunk ${currentChunk}. Falling back to Direct API for remaining chunks.`);
								currentBypass = true; // Set sticky flag
								response = await API.post(`/SDoc/${sDOCID}/attach`, formData, config);
							} else {
								throw ibmErr;
							}
						}
					}
					
					file.chunkStart = end;
					totalUploaded += end - start;

					if (end < file.file.size) {
						// Pass the currentBypass state to the next chunk
						return await uploadChunk(file, currentChunk + 1, fileIndex, currentBypass);
					} else {
						return response; // last chunk of this file
					}
				} catch (error) {
					attempts++;
					if (attempts < 3) {
						await delay(1000);
					} else {
						throw error;
					}
				}
			}
		};

		for (let i = 0; i < files.length; i++) {
			files[i].chunkStart = 0;
			const response = await uploadChunk(files[i], 0, i);
			responses.push(response);

			// ✅ Call onComplete only after the last file
			if (i === files.length - 1 && onComplete) {
				onComplete();
			}
		}

		return responses[responses.length - 1];
	},

	submitWithReason: (sDOCID, userReason) => {
		return IBMAPI.put(`/SDoc/${sDOCID}/submitWithReason`, { userReason })
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err.response
			})
	},

	deleteAdditionalFile: (sDOCID, fileId) => {
		return API.delete(`/SDoc/${sDOCID}/attach/${fileId}`)
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			}
			)
	},
	downloadAdditionalFile: (sDOCId, fileId) => {
		return API.get(`/SDoc/${sDOCId}/attach/${fileId}/download`)
			.then(res => res)
			.catch(err => err)
	},
	billInquiry: (sDocID) => {
		return API.put(`/SDoc/${sDocID}/billinquiry`)
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	billRenew: (sDocID) => {
		return API.put(`/SDoc/${sDocID}/renewbill`)
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	cancelSDoC: (sDocID) => {
		return IBMAPI.put(`/SDoc/${sDocID}/cancelSDoC`)
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
}

export default sDOCAPI
